module.exports = __webpack_public_path__ + "static/media/Logo_Web.6e0bacdb.png";